import { FunctionComponent as F, useEffect, useState } from "react";
import TextField from '@mui/material/TextField';

interface Props
{
  width?: string,
  id?: string,
  initialValue?: string | number,
  type: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  saveValue?: (...args: any) => any,
  handleSubmit?: (value: string) => void
  error?: (value: string) => boolean,
  disabled?: boolean,
  autoSelect?: boolean
}

const EditableInput: F<Props> = (props = {
  initialValue: "",
  type: 'string' }) =>
{
  const initialValueString = String(props.initialValue);
  const [value, setValue] = useState(initialValueString);

  useEffect(() => setValue(initialValueString), [initialValueString]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
  {
    setValue(event.target.value);
  };

  const trySaveValue = () =>
  {
    if(Number(value))
    {
      props.saveValue && props.saveValue(value);

      setValue(value);
    }
    else
    {
      setValue(initialValueString);
    }
  }

  const handleBlur = trySaveValue;

  const handleKeyPress = (event: any) =>
  {
    if(event.key !== 'Enter')
      return;

    trySaveValue();
    return false;
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) =>
  {
    if(props.handleSubmit)
      props.handleSubmit(value);

    event.preventDefault();
  };

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        id={props.id}
        size='small'
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyPress={handleKeyPress}
        error={props.error ? props.error(value) : false}
        style={{ width: props.width, display: 'flex' }}
        disabled={(props.disabled === undefined) ? false : props.disabled}
        inputProps={{ style: {
          padding: '3px',
          paddingLeft: '6px',
          paddingRight: '6px',
          fontSize: 14,
          textAlign: 'right' } }}
        autoComplete={"off"}
        onFocus={props.autoSelect ? e => e.target.select() : undefined} />
    </form>);
};

export default EditableInput;
